import fetch from '@/utils/fetch';

// 创建商品
export function goodsCreate(data = {}) {
  return fetch({
    url: `/saas/cms/m/s/good/create`,
    method: 'post',
    data,
  });
}

// 商品详情
export function goodsView(data = {}) {
  return fetch({
    url: `/saas/cms/m/s/good/view`,
    method: 'post',
    data,
  });
}

// 商品编辑
export function goodsUpdate(data = {}) {
  return fetch({
    url: `/saas/cms/m/s/good/update`,
    method: 'post',
    data,
  });
}
